
import { Component, Vue } from 'vue-property-decorator'
import ZnSelectCurriculumUnit from '@/components/templates/ZnSelectCurriculumUnit.vue'
import { CurriculumUnit, LearningStatusCurriculumUnit } from '@/models/CurriculumUnit'
import { ZnCurriculumUnitsApi } from '@/api/methods/ZnCurriculumUnitsApi'
import { LearningProgress } from '@/const/LearningProgress'

/**
 * 増進堂単元から単元を選択
 */
@Component({
  components: {
    ZnSelectCurriculumUnit,
  },
})
export default class ZnCurriculumUnitConvert extends Vue {
  /**
   * 増進堂単元情報
   */
  private znCurriculumUnit: CurriculumUnit | null = null

  /**
   * 単元情報のリスト
   */
  private curriculumUnitList: LearningStatusCurriculumUnit[] = []

  /**
   * 増進堂単元ID
   *
   * @returns 増進堂単元ID
   */
  private get znCurriculumUnitId(): number {
    return Number(this.$route.params.znCurriculumUnitId)
  }

  /**
   * クエリ保持の系統図ID
   *
   * @returns 系統図ID
   */
  private get systemChartId(): number {
    return Number(this.$route.query.systemChartId)
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    // 増進堂単元に紐づく単元情報を取得
    const znCurriculumUnitConvert = await ZnCurriculumUnitsApi.getZnCurriculumUnitConvert(this.znCurriculumUnitId)

    // 増進堂単元情報設定
    this.znCurriculumUnit = {
      id: znCurriculumUnitConvert.znUnit.id,
      name: znCurriculumUnitConvert.znUnit.name,
    }

    // 単元情報リスト設定
    this.curriculumUnitList = znCurriculumUnitConvert.units.map((unit) => {
      const progress = LearningProgress.findByCode(unit.progress)
      return {
        id: unit.id,
        name: unit.name,
        learningProgress: progress,
      }
    })
  }

  /**
   * 単元クリック時の処理
   *
   * @param id 単元ID
   */
  private async eventClickCurriculumUnit(id: number): Promise<void> {
    await this.$router.push({
      path: `/student/general/${id}`,
      query: this.$prevPage.generateQuery(),
    })
  }

  /**
   * 戻るボタン押下時の処理
   */
  private async eventClickBackButton(): Promise<void> {
    // 系統図ID保持の場合
    if (this.systemChartId) {
      await this.$router.push({
        path: '/student/map',
        query: { systemChartId: `${this.systemChartId}` },
      })
      return
    }

    await this.$router.push('/student/top')
  }
}
